<template>
  <input
    type="checkbox"
    v-model="isChecked"
    class="theme-checkbox"
    @change="onChange"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "ToggleInput",
  data() {
    return {
      isChecked: false,
    }
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  mounted() {
    this.isChecked = this.$props.modelValue
  },
  methods: {
    onChange(event: Event) {
      const target = event.target as HTMLInputElement
      this.$emit("update:modelValue", target.checked)
    },
  },
})
</script>

<style lang="scss" scoped>
.theme-checkbox {
  --toggle-size: 16px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 38px;
  height: 24px;
  background: rgba(255, 255, 255, 0.2);
  transition: 0.4s;
  border-radius: 888px;
  position: relative;
  cursor: pointer;
  font-size: var(--toggle-size);
  outline: none;
}

.theme-checkbox::before {
  content: "";
  width: 19px;
  height: 19px;
  position: absolute;
  top: 2.5px;
  left: 2.5px;
  background: white;
  border-radius: 50%;
  transition: 0.4s;
}

.theme-checkbox:checked {
  background: linear-gradient(
    135deg,
    #00ffaa 0%,
    #4579f5 51.65%,
    #9c42f5 99.83%
  );
}

.theme-checkbox:checked::before {
  left: calc(100% - 22px);
}
</style>
